import { Store } from "redux";
import { settings } from '../../../settings/settings-util';
import reducer from './reducers/index';
import Renderer from "./renderers/renderer";
import { AlmeState } from '../../../wireup/AlmeState';
import { VNode } from "virtual-dom";
import defaultSettings, { EndChatWarningOverlayDefaultSettings } from "./settings/default";
import { showEndChatWarningAction } from './actions/actions';
import LiveChatState from '../../livechat-foundation/src/livechat-state';
import watch from 'redux-watch';

export default class EndChatWarningOverlay {
    //#region Public Interface
    _settings: EndChatWarningOverlayDefaultSettings;
    _store: Store<AlmeState> | null = null;
    _renderer: Renderer;

    constructor(passedSettings: EndChatWarningOverlayDefaultSettings | null | undefined, state: LiveChatState) {
        if (passedSettings && passedSettings.endChatWarning) {
            this._settings = passedSettings;
        } else if (settings && (settings as EndChatWarningOverlayDefaultSettings).endChatWarning) {
            this._settings = settings as EndChatWarningOverlayDefaultSettings;
        } else {
            this._settings = defaultSettings;
        }
        this._renderer = new Renderer(this._settings, state);
    }

    public initialize(store: Store<AlmeState>): void {
        this._store = store;
        this._renderer.initialize(store);
        this.createWatcher();
    }

    public getReducer(): typeof reducer {
        return reducer;
    }

    public getRenderer(): () => VNode {
        return this._renderer.getRender();
    }

    //#endregion

    //#region Flag Methods

    createWatcher(): void {
        const windowLocation = this._settings.stateLocations.Window.Base;
        const endWarningLocation = this._settings.stateLocations.EndChatWarning.Base;
        const endWarningVisibleLocation = this._settings.stateLocations.EndChatWarning.Visible;

        const stateLocation = `${windowLocation}.${endWarningLocation}.${endWarningVisibleLocation}`;

        const visibleWatcher = watch(this._store?.getState.bind(this), stateLocation);

        this._store?.subscribe(visibleWatcher((newVal, oldVal) => {
            if (newVal) {
                this.openWarning();
            }
            else if (!newVal && oldVal !== undefined) {
                this.closeWarning();
            }
        }));
    }

    showWarningOrEndChat(): void {
        const visibleLocation = `${this._settings.stateLocations.EndChatWarning.Base}.${this._settings.stateLocations.EndChatWarning.Visible}`;
        this._store?.dispatch(showEndChatWarningAction(visibleLocation));
    }

    openWarning(): void {
        const warning = this.getWarning();
        if (warning) {
            warning.style.display = "block";
            const yesButton = document.querySelector('.alme--window--end-chat--warning__yes__button') as HTMLButtonElement;
            if (yesButton) {
                yesButton.focus();
            }
        }
    }

    closeWarning(): void {
        const warning = this.getWarning();
        if (warning) {
            warning.style.display = "none";
        }
    }

    //#endregion

    //#region Helper Methods

    getWarning(): HTMLDivElement {
        return document.getElementsByClassName(this._settings.classNames.livechat.endChatWarningShadow)[0] as HTMLDivElement;
    }

    //#endregion
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/livechat-endchat-warning-overlay/src/end-chat-warning-overlay.ts